import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import 'hammerjs';
import { enableDebugTools } from '@angular/platform-browser';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
// import * as Sentry from '@sentry/angular';
// import { Integrations } from '@sentry/tracing';
// Sentry.init({
//   dsn: 'https://ee7ce85d2d224abfaf8647d4650d096c@o350219.ingest.sentry.io/5531888',
//   integrations: [
//     new Integrations.BrowserTracing({
//       tracingOrigins: ['localhost', 'https://yourserver.io/api'],
//       routingInstrumentation: Sentry.routingInstrumentation,
//     }),
//   ],
//   // We recommend adjusting this value in production, or using tracesSampler
//   // for finer control
//   tracesSampleRate: 1.0,
// });
if (environment.production) {
    enableProdMode();
}
__NgCli_bootstrap_2.platformBrowser()
    .bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
    .then((appRef) => enableDebugTools(appRef))
    .catch(err => console.log(err));
